import { createFileRoute } from "@tanstack/react-router";
import DocsArticlePage from "@/pages/docs/DocsArticlePage";

export const Route = createFileRoute("/docs/$group/$slug")({
  component: DocsArticlePage,
});
